<label class="step-header">{{title}}</label>
<button *ngIf="canDecide && isPending" mat-raised-button class="btn-primary float-right" (click)="decide('reject')">Reject</button>
<button *ngIf="canDecide && isPending" mat-raised-button class="btn-primary float-right margin-h-10" [disabled]="isOwnRequest" (click)="decide('approve')">Approve</button>
<p *ngIf="canDecide && isPending && isOwnRequest" class="preview-text">You cannot approve your own request.</p>
<div class="divider"></div>

<p *ngIf="loadError" class="preview-text">{{loadError}}</p>

<div class="view-container main-container shadow-all" *ngIf="request && kind === 'subscription'">
  <div class="row padding-60 flex-row margin-h-10">
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Request Status</p>
      <p class="preview-text preview-terms-color">{{request.requestStatus}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Operation</p>
      <p class="preview-text preview-terms-color">{{request.operation}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Created By</p>
      <p class="preview-text preview-terms-color">{{request.createdBy || '--'}}</p>
    </div>
    <div class="flex-grow-basis" *ngIf="showApprovedBy">
      <p class="preview-text preview-text-color">{{approvedByLabel}}</p>
      <p class="preview-text preview-terms-color">{{request.approvedBy || '--'}}</p>
    </div>
    <div class="divider"></div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Name</p>
      <p class="preview-text preview-terms-color">{{request.name}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">City</p>
      <p class="preview-text preview-terms-color">{{request.cities}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Services</p>
      <p class="preview-text preview-terms-color">{{request.serviceNames}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">User Selectors</p>
      <p class="preview-text preview-terms-color">{{request.userSelectorName}}</p>
    </div>
    <div class="flex-grow-basis" *ngIf="rule.isAutoAssignedToHH">
      <p class="preview-text preview-text-color">HH Subscription</p>
      <p class="preview-text preview-terms-color">true</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Exclude Incentive Types</p>
      <p class="preview-text preview-terms-color">{{rule.excludeIncentiveTypes || '--'}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Priority</p>
      <p class="preview-text preview-terms-color">{{request.priority}}</p>
    </div>
    <div class="divider"></div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Start Date</p>
      <p class="preview-text preview-terms-color">{{request.startDate}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">End Date</p>
      <p class="preview-text preview-terms-color">{{request.endDate}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Rule Amount</p>
      <p class="preview-text preview-terms-color">{{displayOrNA(rule.ruleAmount)}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Striked out Amount</p>
      <p class="preview-text preview-terms-color">{{displayOrNA(rule.strikedOutAmount)}}</p>
    </div>
    <div class="divider"></div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Validity Type</p>
      <p class="preview-text preview-terms-color">{{request.validityType}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Max Value</p>
      <p class="preview-text preview-terms-color">{{displayOrNA(rule.validity && rule.validity[0] && rule.validity[0].maxValue)}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Period in Days</p>
      <p class="preview-text preview-terms-color">{{displayOrNA(rule.periodInDays)}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Rule Type</p>
      <p class="preview-text preview-terms-color">{{request.planType}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Commission Type</p>
      <p class="preview-text preview-terms-color">{{displayOrNA(rule.rule && rule.rule[0] && rule.rule[0].type)}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Commission Value</p>
      <p class="preview-text preview-terms-color">{{displayOrNA(rule.rule && rule.rule[0] && rule.rule[0].value)}}</p>
    </div>
    <div class="flex-grow-basis" *ngIf="rule.ruleTitle">
      <p class="preview-text preview-text-color">Rule Title</p>
      <p class="preview-text preview-terms-color">{{rule.ruleTitle}}</p>
    </div>
    <div class="flex-grow-basis" *ngIf="rule.isRecommended">
      <p class="preview-text preview-text-color">Rule Recommended</p>
      <p class="preview-text preview-terms-color">{{rule.isRecommended}}</p>
    </div>
    <ng-container *ngIf="rule.cashbackValidity">
      <div class="divider"></div>
      <div class="flex-grow-basis">
        <p class="preview-text preview-text-color">Cashback Type</p>
        <p class="preview-text preview-terms-color">{{displayOrNA(rule.cashbackValidity.type)}}</p>
      </div>
      <div class="flex-grow-basis">
        <p class="preview-text preview-text-color">Rides Min Value</p>
        <p class="preview-text preview-terms-color">{{displayOrNA(rule.cashbackValidity.minValue)}}</p>
      </div>
      <div class="flex-grow-basis">
        <p class="preview-text preview-text-color">Cashback Amount</p>
        <p class="preview-text preview-terms-color">{{displayOrNA(rule.cashbackValidity.cashbackAmount)}}</p>
      </div>
    </ng-container>
  </div>
</div>

<div class="view-container main-container shadow-all" *ngIf="request && kind === 'billingPlan'">
  <div class="row padding-60 flex-row margin-h-10">
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Request Status</p>
      <p class="preview-text preview-terms-color">{{request.requestStatus}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Operation</p>
      <p class="preview-text preview-terms-color">{{request.operation}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Created By</p>
      <p class="preview-text preview-terms-color">{{request.createdBy || '--'}}</p>
    </div>
    <div class="flex-grow-basis" *ngIf="showApprovedBy">
      <p class="preview-text preview-text-color">{{approvedByLabel}}</p>
      <p class="preview-text preview-terms-color">{{request.approvedBy || '--'}}</p>
    </div>
    <div class="divider"></div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Name</p>
      <p class="preview-text preview-terms-color">{{request.name}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">City</p>
      <p class="preview-text preview-terms-color">{{request.cities}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Services</p>
      <p class="preview-text preview-terms-color">{{request.serviceNames}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Zones</p>
      <p class="preview-text preview-terms-color">{{request.zoneNames || '--'}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">User Selectors</p>
      <p class="preview-text preview-terms-color">{{request.userSelectorName || '--'}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Priority</p>
      <p class="preview-text preview-terms-color">{{request.priority}}</p>
    </div>
    <div class="divider"></div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">Start Date</p>
      <p class="preview-text preview-terms-color">{{request.startDate}}</p>
    </div>
    <div class="flex-grow-basis">
      <p class="preview-text preview-text-color">End Date</p>
      <p class="preview-text preview-terms-color">{{request.endDate}}</p>
    </div>
    <div class="divider"></div>
    <div class="flex-grow-basis">
      <table class="spacing-table">
        <thead>
          <tr>
            <th class="preview-text preview-text-color">Minimum Rides</th>
            <th class="preview-text preview-text-color">Charged Fee</th>
            <th class="preview-text preview-text-color">StrikeOut Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tier of rule.tiers">
            <td class="preview-text preview-terms-color">{{tier.minValue}}</td>
            <td class="preview-text preview-terms-color">{{tier.amount}}</td>
            <td class="preview-text preview-terms-color">{{tier.strikeOutAmount || '--'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<app-authz-access-hint-footer [authzAccessHint]="authzAccessHint"></app-authz-access-hint-footer>
